<template>
  <v-container>
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs" />
    </div>
    <div class="form-npa private-pg">
      <div class="position">
        <div class="bg-white p-20">
          <div class="form-head">
            <Widget position="menu_profile" />
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn dark v-on="on" class="navbar-toggler-profile">
                  {{ $t('Профиль') }} <span class="caret"></span>
                </v-btn>
              </template>
              <v-list class="navbar-collapse">
                <v-list-item>
                  <Widget position="menu_profile" />
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="form-body">
            <div class="private-section">
              <div>
                <p>
                  {{ $t('Рейтинг сайта') }}: {{ averageRating }}
                  <v-rating
                    v-model="averageRating"
                    half-increments
                    background-color="orange lighten-3"
                    readonly
                    color="orange"
                    hover
                    length="5"
                    class="rating-form__stars mb-2"
                  />
              </p>
              </div>
              <v-simple-table v-if="items.length">
                <thead>
                <tr>
                  <th v-for="(value, field) in tableFields" :key="field">
                    <template>
                      <a @click="sortData(field)">
                        <i class="pro-icon-arrow-bottom1"></i>
                        {{ value }}
                      </a>
                    </template>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>
                    {{ item.ip }}
                  </td>
                  <td>
                    <v-rating
                      v-model="item.mark"
                      background-color="orange lighten-3"
                      readonly
                      color="orange"
                      hover
                      length="5"
                      class="rating-form__stars mb-2"
                    />
                  </td>
                  <td>
                    {{ item.text }}
                  </td>
                  <td>
                    {{ new Date(item.date) | dateFormat('DD.MM.YYYY') }}
                  </td>
                  <td>
                    {{ item.userFio }}
                  </td>
                </tr>
                </tbody>
              </v-simple-table>
              <div class="private-footer">
                <p>{{ $t("Общее количество") }}: {{ itemsTotal }}</p>
              </div>
              <v-pagination
                v-model="page"
                :length="pagesCount"
                :total-visible="10"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import { mapMutations } from 'vuex'
  import Widget from '@/components/app/Widget'
  import Rating from '@/model/rating'
  import {Trans} from "@/plugins/Translation"

  export default {
    components: {
      Widget
    },
    data: () => ({
      breadcrumbs: [],
      tableFields: {},
      items: [],
      sorting: {},
      sortSettings: {
        ip: null,
        mark: null,
        text: null,
        date: null,
        userFio: null
      },
      itemsTotal: 0,
      page: 1,
      pagesCount: 1,
      averageRating: 0
    }),
    watch: {
      $route: 'fetchData',
      page() {
        this.fetchData()
      }
    },
    created() {
      this.fetchData()
    },
    methods: {
      ...mapMutations(['setLoading']),
      fetchData() {
        this.setLoading(true)
        this.sorting.page = this.page
        Rating.getSiteRatingList(this.sorting)
          .then((res) => {
            this.items = res.data.items
            const paginator = res.data.paginationData
            this.itemsTotal = paginator.totalCount
            this.pagesCount = paginator.pageCount
            this.breadcrumbs = [
              {
                text: this.$i18n.t('Профиль'),
                disabled: false,
                href: Trans.currentLocaleUrl + '/profile'
              },
              { text: this.$i18n.t('Оценка портала'), disabled: true }
            ]
            this.tableFields = {
              ip: 'IP',
              mark: this.$i18n.t('Оценка'),
              text: this.$i18n.t('Отзыв'),
              date: this.$i18n.t('Дата'),
              user: this.$i18n.t('Пользователь')
            }
            // Средний рейтинг
            Rating.getAverageRating()
              .then((res) => {
                this.averageRating = res.data.averageRating
              })
              .catch((err) => {
                console.log(err)
              })
            this.setLoading(false)
          })
          .catch((err) => {
            this.$router.push(Trans.i18nRoute({
              name: 'error',
              params: {
                status: err.response.status
              }
            }))
            this.setLoading(false)
          })
      },
      sortData(sortKey) {
        if (
          !this.sortSettings[sortKey] ||
          this.sortSettings[sortKey] === 'desc'
        ) {
          this.sortSettings[sortKey] = 'asc'
        } else {
          this.sortSettings[sortKey] = 'desc'
        }

        this.page = 1

        this.sorting = {
          page: this.page,
          orderBy: sortKey,
          orderDir: this.sortSettings[sortKey]
        }
        this.fetchData()
      },
      scrollToTop() {
        window.scrollTo(0, 0)
      }
    }
  }
</script>
